import {UseCasesImagesContainer} from './UseCasesImagesContainer';
export default UseCasesImagesContainer;